import { jsx as _jsx } from "react/jsx-runtime";
const SvgClose = (props) => (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 15 15", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: _jsx("g", { stroke: "#3B254C", strokeWidth: 2.444, strokeLinecap: "round", children: _jsx("path", { d: "m2 2 11 11M13 2 2 13" }) }) }));
export default SvgClose;
